import { TableRow } from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--table-header-bg)",
    border: "1px solid var(--border-color)",
    color: "var(--text-tertiary)",
    padding: "6px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "6px",
    // Row height used to be set by the now-removed 3-dot IconButton cell
    // (MUI IconButton: ~24px icon + 8px padding ≈ 40px) — every other cell
    // here is just 12px text, so without this the row shrinks to fit that
    // shorter content. Pinned explicitly to keep the old row height now that
    // nothing else in the row is naturally that tall.
    height: 40,
    color: "var(--text-secondary)",
    borderColor: "var(--border-color)",
  },
}));
export const StyledTableRow = styled(TableRow)(({ theme, isExpandable }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: isExpandable ? "var(--bg-highlight)" : "var(--row-bg-odd)",
    border: "1px solid var(--border-color)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: isExpandable
      ? "var(--bg-highlight)"
      : "var(--row-bg-even)",
    border: "1px solid var(--border-color)",
  },

  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
